import { render, staticRenderFns } from "./VsModal.vue?vue&type=template&id=2d58b4a7&scoped=true&"
import script from "./VsModal.vue?vue&type=script&lang=js&"
export * from "./VsModal.vue?vue&type=script&lang=js&"
import style0 from "./VsModal.vue?vue&type=style&index=0&id=2d58b4a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58b4a7",
  null
  
)

export default component.exports